"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryArrayResultTypeIterable = void 0;
/**
 * *** POSTGRES QUERIES ***
 */
exports.QueryArrayResultTypeIterable = ['assetVerification'];
//# sourceMappingURL=PostgresQuery.js.map